<template lang="pug" src="./clientArticleEditor.pug"></template>
<style lang="scss" src="./clientArticleEditor.scss" scoped></style>

<script>
import { validationMixin } from 'vuelidate';
import validate from '@/mixins/validate';
import { required } from 'vuelidate/lib/validators';

export default {
    mixins: [validate, validationMixin],
    data: () => ({
        article: {
            header: null,
            text: null,
            status: 'shown'
        },
        canSaveChanges: false
    }),
    validations: {
        article: {
            header: {
                required
            },
            text: {
                required
            }
        }
    },
    watch: {
        article: {
            handler() {
                this.canSaveChanges = true;
            },
            deep: true
        }
    },
    created() {
        if (this.$route.params.id) {
            this.loadData();
        }
    },
    methods: {
        toggleVisibility() {
            this.article.status = this.article.status === 'shown' ? 'hide' : 'shown';
        },
        async loadData() {
            const articleId = this.$route.params.id;

            await this.$store.dispatch('driverNewsView/getArticleById', articleId).then(data => {
                this.article = data;
            });
        },

        async saveChanges() {
            if (this.$v.article.$invalid) {
                this.$v.article.$touch();
            } else {
                await this.$store.dispatch('driverNewsView/updateArticle', { id: this.$route.params.id, dto: this.article });

                this.$nextTick(() => {
                    this.canSaveChanges = false;
                    this.$v.article.$reset();
                });
            }
        }
    }
};
</script>

